"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMediaUrl = getMediaUrl;
const pluginTypes_1 = require("../types/pluginTypes");
function getMediaUrl(media) {
    let baseUrl = process.env.GATSBY_SYLEX_MEDIA_URL;
    const env = process.env.LOCATION?.toUpperCase() ||
        pluginTypes_1.SylexEnvironment.DEVELOPMENT.toUpperCase();
    if (!baseUrl) {
        baseUrl =
            pluginTypes_1.SylexMediaUrls[env] ??
                pluginTypes_1.SylexMediaUrls.DEVELOPMENT;
    }
    const path = env === 'DEVELOPMENT' ? media?.url : `/${media?.filename}`;
    return `${baseUrl}${path}`;
}
